import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../StudentDashboard/Sidebar";
import Header from "../StudentDashboard/Headers";
import MyProfile from "./MyProfile";
import { API_URL } from "../../config/api";

const Parent = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserAndCourses = async () => {
      try {
        const token = localStorage.getItem("access_token");

        if (!token) {
          console.error(" No access token found in localStorage");
          setLoading(false);
          return;
        }

        // 1️⃣ GET CURRENT USER
        console.log("🌐 Calling →", `${API_URL}/current_user`);

        const currentUser = await axios.get(`${API_URL}/current_user`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        console.log("✅ CURRENT USER RESPONSE →", currentUser.data);

        const userId = currentUser.data?.user_id;

        if (!userId) {
          console.error(" user_id missing in /current_user response");
          setLoading(false);
          return;
        }

        // 2️⃣ GET FULL USER DETAILS
        console.log("🌐 Calling →", `${API_URL}/user/${userId}`);

        const userDetailRes = await axios.get(`${API_URL}/user/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        console.log(" RAW USER DETAIL RESPONSE →", userDetailRes.data);

        const formattedUser =
          userDetailRes.data?.data || userDetailRes.data || null;

        console.log(" FINAL USER OBJECT SET TO STATE →", formattedUser);

        setUserData(formattedUser);
      } catch (error) {
        console.error(" ERROR FETCHING USER →", error);

        if (error.response) {
          console.log(" ERROR RESPONSE →", error.response.data);
          console.log(" STATUS →", error.response.status);
        } else if (error.request) {
          console.log(" NETWORK / CORS ERROR →", error.request);
        } else {
          console.log(" UNKNOWN ERROR →", error.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserAndCourses();
  }, []);

  // ===========================
  // Loading UI
  // ===========================
    if (loading) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4AACC5] mx-auto"></div>
      </div>
    </div>
  );
}

  // ===========================
  // Error UI
  // ===========================
  if (!userData) {
    console.log("⚠️ userData is NULL — cannot load dashboard UI.");
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-600">
        Unable to load user data. Please log in again.
      </div>
    );
  }

  // ===========================
  // Dashboard Layout
  // ===========================
  return (
    <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
      {/* Header */}
      <div className="flex-shrink-0">
        <Header userData={userData} />
      </div>

      {/* Layout */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div className="w-56 bg-white border-r border-neutral-200 flex-shrink-0">
          <Sidebar />
        </div>

        {/* Page Content */}
        <div className="flex-1 p-4 overflow-y-auto">
          <MyProfile userData={userData} />
        </div>
      </div>
    </div>
  );
};

export default Parent;
